<!-- Enhanced Slideshow Container -->
@if (isVisible()) {
  <div
      class="enhanced-slideshow-container"
      [class.playing]="isPlaying()"
      [class.paused]="!isPlaying()">
    <!-- Modal Container - Using new SlideShowModal component -->
    <app-slide-show-modal
        [isPlaying]="isPlaying()"
        (modalClick)="onSlideClick()">
      <!-- Media Segments Indicator -->
      <app-progress-bar
          [totalMediaItems]="mediaItems().length"
          [currentIndex]="currentIndex()"
          (segmentClick)="onSegmentClick($event)">
      </app-progress-bar>
      <!-- Main Slide Content - always rendered to prevent layout reflow -->
      <div class="slide-content">
        @if (currentMediaItem(); as media) {
          <app-slide-display
            #slideDisplay
            [currentMedia]="media"
            [controlsVisible]="getControlsVisible()"
            [mobileControlsVisible]="mobileControlsVisible()"
            [kenBurnsEffect]="getCurrentKenBurnsEffect() || undefined"
            [slideIndex]="currentIndex()"
            [canGoNext]="!isLastSlide()"
            [canGoPrevious]="!isFirstSlide()"
            (mouseEnter)="onSlideContentMouseEnter()"
            (mouseLeave)="onSlideContentMouseLeave()"
            (videoTouchStart)="onVideoTouchStart($event)"
            (videoTouchEnd)="onVideoTouchEnd($event)"
            (videoControlsTouch)="onVideoControlsTouch()"
            (videoTimeUpdate)="onVideoTimeUpdate()"
            (videoEnded)="onVideoEnded()"
            (videoPlay)="onVideoPlay()"
            (videoPause)="onVideoPause()"
            (videoLoadedMetadata)="onVideoLoadedMetadata()"
            (next)="nextSlide()"
            (previous)="previousSlide()"
          ></app-slide-display>
        }

        <!-- Top Controls Overlay -->
        <app-top-controls
            [currentIndex]="currentIndex()"
            [totalSlides]="mediaItems().length"
            [isLoading]="isLoadingAlternatives()"
            (close)="close()">
        </app-top-controls>
      </div>
      <!-- Content Area (45% height) - Using new ContentArea component -->
      <div class="content-area-wrapper">
        <app-content-area
            [currentSong]="currentSong()"
            [currentDescription]="currentDescription()"
            [hasAudioResults]="hasAudioResults()"
            [isLoadingAlternatives]="isLoadingAlternatives()"
            [audioResults]="audioResults()"
            [audioService]="audioService"
            [showInitialLoading]="!hasMedia()"
            (requestAlternativePrompt)="handleRequestAlternativePrompt()"
            (playPreviousSong)="playPreviousSong()"
            (playNextSong)="playNextSong()"
            (volumeUpdated)="onVolumeUpdated($event)">
        </app-content-area>
      </div>
    </app-slide-show-modal>
  </div>
}
